import React from 'react';
import {Images} from "../../utils/images";
import {H2, H5, P1} from "../shared/fonts/fonts";
import {ButtonPU} from "../shared/buttons/buttons";
import {Buttons, ResultFormStyle} from "./Success";
import User from "../../entities/User";
import {Message} from "../shared/calendar/Card";
import {URLs} from "../../utils/constants";

const Error = () => {
  return (
    <ResultFormStyle>
      <img src={Images.icons.cancelled}/>
      <H2>Ошибка при оплате</H2>
      <P1>Оплата не прошла. Попробуйте заново.</P1>
      <Buttons>
        <Message href={URLs.chat}>
          <img src={Images.icons.message_blue}/>Помощь
        </Message>
        <ButtonPU href={User.linkToView()}><H5>Личный кабинет</H5></ButtonPU>
      </Buttons>
    </ResultFormStyle>
  );
};

export default Error;